import { Deposit,Summary } from './../constants/actionType'
const initialState = {
    isSubmitOrder: false,
    submitOrderClicked:false,
    orderPlaced:false,
    offferDiscailmer:false,
    placeOrderCTAClicked: false,
    deposit: {
        depositPaymentClicked: false,
        depositAddressCheck: false,
        debitCheck: false,
        firstName: "",
        lastName: "",
        cardNumber: "",
        cardType: "",
        securityCode: "",
        expirationDate: {
            Month: "",
            Year: ""
        },
        street: "",
        city: "",
        stateVal: "",
        zip: "",
        response: "",
        depositAttempts: 0,
        depositStatus: "",
        fNameErr: false,
        lNameErr: false,
        cTypeErr: false,
        cNumErr: false,
        cVVErr: false,
        expMonthErr: false,
        expYearErr: false,
        cityErr:false,
        streetValErr:false,
        stateValErr:false,
        zipErr:false
    },
    sendRTCIP:"",
    encZip:"",
    encMon:"",
    isDataInOrder:false,
    isDataGig:false,
    isAuthenticatedFlag:""
};

function submitOrder(state = initialState, action) {
    switch (action.type) {
        case 'SO_SUBMIT_ORDER_SUCCESS':
            return Object.assign({}, state, {
                isSubmitOrder: action.value
            })
        case 'SO_SUBMIT_ORDER_FAILURE':
            return Object.assign({}, state, {
                isSubmitOrder: action.value
            })
        case 'SUBMIT_ORDER_CLICKED':
            return Object.assign({}, state, {
                submitOrderClicked: action.value
            })
        case 'PLACE_ORDER_CTA_CLICKED':
            return Object.assign({}, state, {
                placeOrderCTAClicked: action.value
            }) 
        case Summary.orderPlaced:
            return Object.assign({}, state, {
                orderPlaced: action.value
            })
        case 'SUMMARY_OFFERDISCLAIMER':
            return Object.assign({}, state, {
                offferDiscailmer: !action.value
            })                      
        case Deposit.depositPaymentClicked:
            let paymentClick = Object.assign({}, state.deposit, {
                depositPaymentClicked: action.value
            })
            return Object.assign({}, state, {
                deposit: paymentClick
            })

        case Deposit.depositAddressCheck:
            let depositCheck = Object.assign({}, state.deposit, {
                depositAddressCheck: !action.value
            })
            return Object.assign({}, state, {
                deposit: depositCheck
            })
        case Deposit.onUpdateDeposit:
            let getDepositresponse = Object.assign({}, state.deposit, {
                response: action.value
            })
            return Object.assign({}, state, {
                deposit: getDepositresponse
            })
        case Deposit.depositdebitCheck:
            let debitCheck = Object.assign({}, state.deposit, {
                debitCheck: !action.value
            })
            return Object.assign({}, state, {
                deposit: debitCheck
            })
        case Deposit.validateDeposit:
            let deposit = Object.assign({}, state.deposit, {
                firstName: action.value.firstName !== undefined &&
                    action.value.firstName !== state.deposit.firstName ? action.value.firstName : state.deposit.firstName,
                lastName: action.value.lastName !== undefined &&
                    action.value.lastName !== state.deposit.lastName ? action.value.lastName : state.deposit.lastName,
                cardNumber: action.value.cardNumber !== undefined &&
                    action.value.cardNumber !== state.deposit.cardNumber ? action.value.cardNumber : state.deposit.cardNumber,
                cardType: action.value.cardType !== undefined &&
                    action.value.cardType !== state.deposit.cardType ? action.value.cardType : state.deposit.cardType,
                expirationDate: {
                    Month: action.value.Month !== undefined &&
                        action.value.Month !== state.deposit.expirationDate.Month ? action.value.Month : state.deposit.expirationDate.Month,
                    Year: action.value.Year !== undefined &&
                        action.value.Year !== state.deposit.expirationDate.Year ? action.value.Year : state.deposit.expirationDate.Year
                },
                securityCode: action.value.securityCode !== undefined &&
                    action.value.securityCode !== state.deposit.securityCode ? action.value.securityCode : state.deposit.securityCode,
                street: action.value.street !== undefined &&
                    action.value.street !== state.deposit.street ? action.value.street : state.deposit.street,
                city: action.value.city !== undefined &&
                    action.value.city !== state.deposit.city ? action.value.city : state.deposit.city,
                stateVal: action.value.state !== undefined &&
                    action.value.state !== state.deposit.stateVal ? action.value.state : state.deposit.stateVal,
                zip: action.value.zip !== undefined &&
                    action.value.zip !== state.deposit.zip ? action.value.zip : state.deposit.zip,
            })
            return Object.assign({}, state, {
                deposit: deposit,
            })
        case Deposit.updateDepositAttempts:
            let attempts = Object.assign({}, state.deposit, {
                depositAttempts: action.value
            })
            return Object.assign({}, state, {
                deposit: attempts
            })
        case Deposit.updateDepositStatus:
            let status = Object.assign({}, state.deposit, {
                depositStatus: action.value
            })
            return Object.assign({}, state, {
                deposit: status
            })
        case Deposit.fNameErr:
            let fNameError = Object.assign({}, state.deposit, {
                fNameErr: action.value
            })
            return Object.assign({}, state, {
                deposit: fNameError
            })
        case Deposit.lNameErr:
            let lNameError = Object.assign({}, state.deposit, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                deposit: lNameError
            })
        case Deposit.cTypeErr:
            let cTypeError = Object.assign({}, state.deposit, {
                cTypeErr: action.value
            })
            return Object.assign({}, state, {
                deposit: cTypeError
            })
        case Deposit.cNumErr:
            let cNumError = Object.assign({}, state.deposit, {
                cNumErr: action.value
            })
            return Object.assign({}, state, {
                deposit: cNumError
            })
        case Deposit.cVVErr:
            let cVVError = Object.assign({}, state.deposit, {
                cVVErr: action.value
            })
            return Object.assign({}, state, {
                deposit: cVVError
            })
        case Deposit.expMonthErr:
            let expMonthError = Object.assign({}, state.deposit, {
                expMonthErr: action.value
            })
            return Object.assign({}, state, {
                deposit: expMonthError
            })
        case Deposit.expYearErr:
            let expYearError = Object.assign({}, state.deposit, {
                expYearErr: action.value
            })
            return Object.assign({}, state, {
                deposit: expYearError
            })
        case Deposit.cityErr:
            let depositCity = Object.assign({}, state.deposit, {
                cityErr: action.value
            })
            return Object.assign({}, state, {
                deposit: depositCity
            })
        case Deposit.streetErr:
            let depositStreet = Object.assign({}, state.deposit, {
                streetErr: action.value
            })
            return Object.assign({}, state, {
                deposit: depositStreet
            })
        case Deposit.stateValErr:
            let depositStateVal = Object.assign({}, state.deposit, {
                stateValErr: action.value
            })
            return Object.assign({}, state, {
                deposit: depositStateVal
            })
        case Deposit.zipErr:
            let depositZip = Object.assign({}, state.deposit, {
                zipErr: action.value
            })
            return Object.assign({}, state, {
                deposit: depositZip
            })
        case 'SEND_RTCIP':
            return Object.assign({}, state, {
                sendRTCIP: action.value
            })
        case 'SET_ENC_ZIP':
            return Object.assign({}, state, {
                encZip: action.value
            })
        case 'SET_ENC_MON':
            return Object.assign({}, state, {
                encMon: action.value
            })
        case 'MNH_BANNER_DECIDER':
            return{
                ...state,
                isDataInOrder:action.isDataInOrder,
                isDataGig:action.isDataGig
            }
        case 'BANNER_DISPLAY_ORDERSUMMARY':
            return Object.assign({}, state, {
                isAuthenticatedFlag:action.value
            })                
        default:
            return state
    }

}

export default submitOrder